import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';

import { get_effects_data } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';
import PaginationCmp from '../../../../Components/Pagination/PaginationCmp';
import { Header } from '../../../../Components/Header';
import { THead } from '../../../../Components/Table';

import './effects.css';

export const Effects = ({ title }) => {
  const navigate = useNavigate();
  const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
  const simpleFields = ["Id", "Name", "Preview"];
  const dropdownFields = ["Premium", "Active"];
  const totalFields = simpleFields.length + dropdownFields.length + 2;

  let handleSwitch = (e) => {
    setDeleteUpdateYes("updateeffects");
    setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
    setConfirmationModalShow(!confirmationModalShow)
  };

  const getEffectsData = async (_currentPage = 1) => {
    setIsLoading(true);
    try {
      const getEffects = await get_effects_data(_currentPage, perPage, search, filterDropdown);
      if (getEffects) {
        const { status, data, currentPage, perPage, totalPage } = getEffects;
        if (status) {
          // console.log(data);
          setCurrentTableData(data);
          setCurrentPage(currentPage);
          setPerPage(perPage);
          setTotalPage(totalPage);
        } else {
          // toast.error(message);
          setCurrentTableData([]);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getEffectsData(currentPage);
  }, [deleteUpdateTag, search, filterDropdown]);

  useEffect(() => {
    document.title = `Emoji Keyboard | ${title}`
  }, []);

  return (
    <div className='table-header-main ms-auto p-3'>
      <Header title={`Effects`} previewLink={`/preview`} addLink={`/effectsform`} deleteUpdateTag={"alldeleteeffects"} />
      <Table striped bordered hover responsive className='mb-3'>
        <THead
          simpleFields={simpleFields}
          dropdownFields={dropdownFields}
        />
        <tbody>
          {
            isLoading ?
              <tr>
                <td colSpan={totalFields} className='py-5'>
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" />
                  </div>
                </td>
              </tr>
              : currentTableData.length === 0 ?
                <tr>
                  <td colSpan={totalFields} className='py-5 bg-light'>
                    <div className="d-flex justify-content-center align-items-center">
                      No Data Found
                    </div>
                  </td>
                </tr>
                : currentTableData.map((_ele, i) => (
                  <tr key={i} className="align-middle">
                    <td>
                      <Form.Check
                        type={'checkbox'}
                        id={`effects-${_ele._id}`}
                        value={`${_ele._id}`}
                        checked={checkedValues.includes(`${_ele._id}`)}
                        onChange={() => handleCheckboxChange(`${_ele._id}`)}
                      />
                    </td>
                    <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                    <td>{_ele.name}</td>
                    <td>
                      <div className='imgTd position-relative'>
                        <img className='table-preview_img position-absolute d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                        <Zoom>
                          <img className='table-preview_img d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                        </Zoom>
                      </div>
                    </td>
                    {
                      ["isPremium", "isActive"].map((_is_ele, i) => (
                        <td key={i}>
                          {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal">
                            {_is_ele ? `On` : `Off`}
                          </Badge> */}
                          <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                        </td>
                      ))
                    }
                    <td>
                      <div className='d-flex action-btns'>
                        {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                        <Button className='px-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                          <MdFileCopy color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                        <Button className='px-2 me-2' variant="warning" onClick={() => navigate(`/effectsform`, { state: _ele })}>
                          <MdEditSquare color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}

                        {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                        <Button className='px-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deleteeffects"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                          <MdDelete color='black' size={"18px"} />
                        </Button>
                        {/* </TooltipCmp> */}
                      </div>
                    </td>
                  </tr>
                ))
          }
        </tbody>
      </Table>
      <div className={`table-pagination d-flex justify-content-end ${currentTableData.length > 0 ? 'd-block' : 'd-none'}`}>
        <PaginationCmp
          currentPage={currentPage}
          totalPage={totalPage}
          getData={getEffectsData}
        />
      </div>
    </div>
  )
};

Effects.defaultProps = {
  title: "Effects"
};

export default Effects;